<template>
  <v-container
    id="fees"
    class="pa-0"
    fluid
    tag="section"
  >
    <v-row
      class="ma-0"
      no-gutters
    >
      <v-col
        cols="12"
        md="4"
      >
        <v-img
          class="hidden-sm-and-down"
          height="calc(100vh - 96px - 150px)"
          :src="require('@/assets/daffodils.png')"
        />
      </v-col>

      <v-col
        class="d-block d-md-flex grey lighten-3 pa-6"
        cols="12"
        md="8"
      >
        <v-responsive
          class="mx-auto px-3 px-md-12"
        >
          <h1
            class="mb-6"
            :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1'"
          >
            Fees
          </h1>
          <p>Counselling sessions are 60-minutes long.</p>
          <p>
            I offer a <b>free 15-minute telephone consultation</b> to see whether counselling is right for you and for you
            to see whether I am the right counsellor for you.
          </p>
          <p>
            If we decide to proceed, the counselling fee is <b>£35 per 60-minute session</b> for face-to-face, telephone, or online counselling
            (<b>£50 for couples</b>).
          </p>
          <p>
            <b>How to pay:</b> Payment can be made by cash for face-to-face counselling or securely via Stripe for telephone or online counselling.
            Advance payment is required for telephone or online counselling.
            <a
              class="ma-3 d-block"
              href="https://buy.stripe.com/bIY03Qbgagrx9EseUU"
              target="_blank"
            >Pay £35 for your counselling session (1 hour)</a>
            <a
              class="ma-3 d-block"
              href="https://buy.stripe.com/bIY9EqbgaejpcQE7su"
              target="_blank"
            >Pay £50 for a couples counselling session (1 hour for two people)</a>
          </p>
          <p>
            <b>Cancellation policy:</b> if you cancel a session more than 24-hours in advance, and have paid in advance, you will be fully refunded for that session.
            If you cancel with less notice, or do not attend your session, I reserve the right to charge for the session unless there
            is a significant reason (e.g. illness or family emergency). Should I need to cancel a session for any reason, you will be refunded
            regardless.
          </p>
          <p>Should you need multiple sessions, or ongoing therapy, we will jointly review whether counselling is working for you, regularly.</p>
        </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Fees',
  }
</script>

<style lang="sass">
</style>
